import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { TranslateService } from '@ngx-translate/core';
import { ModalDirective } from 'ngx-bootstrap';

import { SiterecordCoordinatesChange } from 'app/models/siterecord-coordinates-change.model';

@Component({
  selector: 'app-dialog-edit-coordinates',
  templateUrl: './dialog-edit-coordinates.component.html',
  styleUrls: ['./dialog-edit-coordinates.component.scss']
})
export class DialogEditCoordinatesComponent implements OnInit {
  @ViewChild('confirmCoordinatesDialog') confirmCoordinatesDialog: ModalDirective;
  @ViewChild('coordinatesForm') public coordinatesForm: NgForm = null;

  @Input() latitude: string;
  @Input() longitude: string;

  @Output() onConfirm = new EventEmitter<SiterecordCoordinatesChange>();
  @Output() onCancel = new EventEmitter();

  constructor(protected readonly translateService: TranslateService) {}

  ngOnInit() {}

  public show(): void {
    this.confirmCoordinatesDialog.show();
  }

  public confirm(): void {
    const { lat, lon, bearing } = this.coordinatesForm.value;

    this.confirmCoordinatesDialog.hide();

    this.onConfirm.emit(new SiterecordCoordinatesChange(lat, lon, bearing));
  }

  public cancel(): void {
    this.confirmCoordinatesDialog.hide();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/dialog-edit-coordinates/dialog-edit-coordinates.component.ts